import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class ValveNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.Valve,
    });
  }
}
